/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * QubePro DataTable sayfa boyutu sözleşmesinin web tarafındaki tek kaynağıdır.
 */

export const PAGE_SIZE_OPTIONS = [5, 20, 50, 100] as const;
export const DEFAULT_PAGE_SIZE = 20;

export function normalizePageSize(value: unknown): number {
  const numeric = Number(value);
  return PAGE_SIZE_OPTIONS.includes(numeric as (typeof PAGE_SIZE_OPTIONS)[number])
    ? numeric
    : DEFAULT_PAGE_SIZE;
}
